import { render } from "./SendSms.vue?vue&type=template&id=34025d04&scoped=true"
import script from "./SendSms.vue?vue&type=script&lang=js"
export * from "./SendSms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-34025d04"

export default script